import { Grid, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../configs/colors';

export const MainGrid = styled(Grid)`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: 10px;
  border: 2px solid ${COLORS.CardBorder};
  padding: 10px;
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
`;

export const ChipRow = styled(Stack)`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
`;
